import { render, staticRenderFns } from "./Resumo.vue?vue&type=template&id=06ade899"
import script from "./Resumo.vue?vue&type=script&lang=ts"
export * from "./Resumo.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports